import React from "react";
import {
  FaRocket,
  FaUsers,
  FaShieldAlt,
  FaProjectDiagram,
} from "react-icons/fa";

function EarlyAccess() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Features of a Crypto Launchpad
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-one-items">
                  {/* 1 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaRocket size={40} />
                      </div>
                      <h4>Early Access to Token Sales</h4>
                      <p>
                        Investors gain access to promising projects at lower
                        prices.
                      </p>
                    </div>
                  </div>

                  {/* 2 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaUsers size={40} />
                      </div>
                      <h4>Community Engagement</h4>
                      <p>
                        Projects can build a community and generate interest
                        before their full launch.
                      </p>
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaShieldAlt size={40} />
                      </div>
                      <h4>Secure Fundraising Process</h4>
                      <p>
                        Most launchpads include KYC/AML protocols and smart
                        contract audits to ensure a secure fundraising.
                      </p>
                    </div>
                  </div>

                  {/* 4 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaProjectDiagram size={40} />
                      </div>
                      <h4>Multi-Blockchain Support</h4>
                      <p>
                        Many launchpads support different blockchains, allowing
                        projects to choose the best network for their needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EarlyAccess;
